import React from "react"
import Image from "components/image";
import Button from "components/button";
import RichText from "components/richText";

import "blocks/theme-picker.scss";
import styles from "./full-page-photo-matrix.module.scss";

const FullPagePhotoMatrix = ({ themePicker, fullPagePhotoMatrix }) => {

  return (
    <div className={`${themePicker} ${styles.fullPagePhotoWrapper}`}>
      {fullPagePhotoMatrix.map((elem) => {
        if (elem.__typename === "header_Entry") {
          return (
            <h1 key={elem.id} className={styles.header}>{elem.header}</h1>
          );
        } else if (elem.__typename === "fullPagePhoto_Entry") {
          if (elem.photoBorderSwitch) {
            return (
              <figure key={elem.id} className={styles.imageBorder}>
                {elem.image[0].extension === "svg" ?
                  <Image extension={elem.image[0].extension} url={elem.image[0].url} alt={elem.altText} title={elem.image[0].title} />
                  : <Image {...elem.image[0].optimized} title={elem.image[0].title} alt={elem.altText} />
                }
              </figure>
            );
          } else {
            return (
              <figure key={elem.id} className={styles.noImageBorder}>
                {elem.image[0].extension === "svg" ?
                  <Image extension={elem.image[0].extension} url={elem.image[0].url} alt={elem.altText} title={elem.image[0].title} />
                  : <Image {...elem.image[0].optimized} alt={elem.altText} title={elem.image[0].title} />
                }
              </figure>
            );
          }
        } else if (elem.__typename === "introBody_Entry") {
          return (
            <p key={elem.id} className={styles.introBody}> {elem.introBody} </p>
          );
        } else if (elem.__typename === "subheader_Entry") {
          return (
            <h3 key={elem.id} className={styles.fullPageSubheader}> {elem.subheader} </h3>
          );
        } else if (elem.__typename === "body_Entry") {
          return (
            <div key={elem.id} className={styles.body}>
              <RichText
                richText={elem.body}
                textColor="blue"
              />
            </div>
          );

        } else if (elem.__typename === "cta_Entry") {
          return (
            <div key={elem.id} className={styles.cta}>
              <Button
                primary={true}
                theme="blue"
                {...elem.cta}
              ></Button>
            </div>
          );
        }
        return (null);
      })}

    </div>

  );
}

export default FullPagePhotoMatrix